import { DeliveryStatus, DeliveryType } from "@types_def/models/delivery.types";
import {
  canUseAdminDeliveryActions,
  canViewDeliveryActions,
} from "@/components/Delivery/view-delivery-button-access";

type DeliveryStatusFlagsInput = {
  status: DeliveryStatus;
  type: DeliveryType;
  isAdmin: boolean;
  rank: number | undefined;
};

export function getDeliveryStatusFlags({ status, type, isAdmin, rank }: DeliveryStatusFlagsInput) {
  const isRequestedStatus = [
    DeliveryStatus.REQUESTED,
    DeliveryStatus.PENDING_CUSTOMER_CONFIRMATION,
    DeliveryStatus.SMS_SENT,
    DeliveryStatus.CONFIRMED_BY_CUSTOMER,
  ].some((candidate) => candidate === status);

  const isCompletedStatus = status === DeliveryStatus.COMPLETED;
  const isConfirmedStatus = status === DeliveryStatus.CONFIRMED;

  const isActiveAdminStatus = [
    DeliveryStatus.CONFIRMED,
    DeliveryStatus.WAITING_FOR_DRIVER,
    DeliveryStatus.ALERT,
    DeliveryStatus.SET,
  ].some((candidate) => candidate === status);

  const isInitialStatus = [
    DeliveryStatus.WAITING_FOR_DRIVER,
    DeliveryStatus.CONFIRMED,
    DeliveryStatus.REQUESTED,
  ].some((candidate) => candidate === status);

  const isCancelledStatus = [
    DeliveryStatus.CANCELLED_BY_ADMIN,
    DeliveryStatus.CANCELLED,
    DeliveryStatus.CANCELLED_BY_CUSTOMER,
    DeliveryStatus.CANCELLED_BY_MANDATORY,
  ].some((candidate) => candidate === status);

  const isOngoingStatus = [
    DeliveryStatus.PICKUP_CLIENT,
    DeliveryStatus.PICKUP_DRIVER,
    DeliveryStatus.ONGOING,
    DeliveryStatus.SWAP_DELIVERED,
    DeliveryStatus.DELIVERED,
    DeliveryStatus.SWAP_IN_TRANSIT,
    DeliveryStatus.SWAP_PICKUP_CLIENT,
    DeliveryStatus.SWAP_PICKUP_DRIVER,
  ].some((candidate) => candidate === status);

  const isDeliveryCodeVisible = [
    DeliveryStatus.SET,
    DeliveryStatus.PICKUP_CLIENT,
    DeliveryStatus.PICKUP_DRIVER,
    DeliveryStatus.ONGOING,
  ].some((candidate) => candidate === status);

  const isTwoWayDelivery = type === DeliveryType.TWO_WAY_DELIVERY;
  const canManageAdminActions = canUseAdminDeliveryActions(Boolean(isAdmin), rank);
  const canSeeActions = canViewDeliveryActions(Boolean(isAdmin), status);

  return {
    isRequestedStatus,
    isCompletedStatus,
    isConfirmedStatus,
    isActiveAdminStatus,
    isInitialStatus,
    isCancelledStatus,
    isOngoingStatus,
    isDeliveryCodeVisible,
    isTwoWayDelivery,
    canManageAdminActions,
    canSeeActions,
  };
}
